
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/shipping-and-delivery",
      function () {
        return require("private-next-pages/policies/shipping-and-delivery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/shipping-and-delivery"])
      });
    }
  